import ResizeObserver from 'resize-observer-polyfill';

export enum DomOrigin {
  REQUEST_SERVER = 'request-server',
  CONTENT_SERVER = 'content-server',
}

type HTMLElementContent = string | { toString: () => string };

interface GlobalConfig {
  brightcoveAccountId: string;
  brightcovePlayerId: string;
  cludoCustomerId: string;
  cludoEngineId: string;
  cognitoUserpoolClientId: string;
  cognitoUserpoolId: string;
  domOrigin: DomOrigin;
  locale: string;
  pageId: string;
  recaptchaKey: string;
  translationUrl: string;
  whiteListedDomains: string;
  baseDomain: string;
  formsApi: string;
}

export enum Key {
  ENTER = 13,
  SPACE = 32,
  ESCAPE = 27,
  UP = 38,
  DOWN = 40,
  A = 65,
  Z = 90,
}

export const DomService = {
  createElement(tagName: string, content: HTMLElementContent = '', props: Record<string, string> = {}): HTMLElement {
    const element = document.createElement(tagName);
    element.innerHTML = typeof content === 'string' ? content : content.toString();
    Object.keys(props).forEach((prop) => {
      element.setAttribute(prop, props[prop]);
    });
    return element;
  },

  createObserver(element: HTMLElement, callback: ((_: ResizeObserverEntry[]) => void)) {
    if (!(element instanceof Element)) {
      return;
    }
    const observer = new ResizeObserver((entries) => callback(entries));
    observer.observe(element);
  },

  getGlobalConfig(): GlobalConfig {
    const element = document.body.querySelector('roche-global-config') as HTMLElement;
    return { ...(element ? element.dataset : {}) } as unknown as GlobalConfig;
  },

  // TODO: Change any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getGlobalHeader(): any {
    return document.querySelector('roche-header');
  },

  /**
   * Mimics Element.closest() but transverses Shadow Dom
   * https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
   */
  closestElement(selector: string, base: Element = this): Element {
    // eslint-disable-next-line no-underscore-dangle
    function __closestFrom(el: Element | Window | Document): Element {
      if (!el || el === document || el === window) return null;
      const found = (el as Element).closest(selector);
      return found || __closestFrom(((el as Element).getRootNode() as ShadowRoot).host);
    }
    return __closestFrom(base);
  },

  lockBody() {
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
  },

  unlockBody() {
    document.body.style.height = '';
    document.body.style.overflow = '';
  },

  getLocationHostname(): string {
    // eslint-disable-next-line compat/compat
    return window.location.hostname;
  },
};
